import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Notification, useNotifications } from './useNotifications';

/**
 * Page-level hook for notifications page (web-specific navigation logic).
 * For React Native, create a similar hook using React Navigation instead of react-router-dom.
 */
export interface UseNotificationsPageResult {
  handleNotificationClick: (notification: Notification) => void;
}

export function useNotificationsPage(): UseNotificationsPageResult {
  const navigate = useNavigate();
  const { hasUnread, markAllAsRead, tripUrls } = useNotifications();

  // Auto-mark all notifications as read when page mounts
  useEffect(() => {
    if (hasUnread) {
      markAllAsRead();
    }
  }, [hasUnread, markAllAsRead]);

  const handleNotificationClick = useCallback(
    (notification: Notification) => {
      const url = tripUrls[notification.tripId];
      if (url) {
        navigate(url);
      }
    },
    [navigate, tripUrls],
  );

  return {
    handleNotificationClick,
  };
}
